function renderCoreEmailProviderContentTemplate({
  activeProviderExportName
}: {
  activeProviderExportName: string
}): string {
  return `  if (${activeProviderExportName}.isConfigured()) {
    return ${activeProviderExportName}
  }

`
}

function renderCoreEmailProviderGeneratedFunctionTemplate({
  providerImport,
  providerBranch
}: {
  providerImport: string
  providerBranch: string
}): string {
  return `import { noneEmailProvider } from '@admin/actions/email/none'
${providerImport}import type { AdminEmailProvider } from '@admin/actions/email/types'

export function getEmailProvider(): AdminEmailProvider {
${providerBranch}  return noneEmailProvider
}
`
}

export function renderCoreEmailProviderRenderer(
  request:
    | {
        kind: 'renderCoreEmailProviderContentTemplate'
        props: {
          activeProviderExportName: string
        }
      }
    | {
        kind: 'renderCoreEmailProviderGeneratedFunctionTemplate'
        props: {
          providerImport: string
          providerBranch: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderCoreEmailProviderContentTemplate':
      return renderCoreEmailProviderContentTemplate(request.props)
    case 'renderCoreEmailProviderGeneratedFunctionTemplate':
      return renderCoreEmailProviderGeneratedFunctionTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
